import React, { useEffect, useRef, useState } from "react";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import DefaultHeading from "../../components/heading/DefaultHeading";
import { Duration, User } from "./deletePJPTypes";
import DurationFilter from "../../components/deletePJP/durationFilter/DurationFilter";
import { Loader } from "../../components/loader/Loader";
import "./deletePJP.css";
import UsersInfo from "../../components/deletePJP/usersInfo/UsersInfo";
import { fetchUsers } from "./deletePJPService";
import { PjpPlanConfig } from "../pjpApproval/PjpApprovalServices";
import { openPopup } from "../../stateManagement/actions/popupActions";
const DeletePJP = () => {
  const { translate } = usePortalTranslation();
  const [duration, setDuration] = useState<Duration | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [users, setUsers] = useState<User[]>([]);
  const pjpPlanOption = useRef<any>(null);
  const getUsers = async (duration: Duration,showPopup: boolean = true) => {
    try {
      setLoading(true);
      const fetchedUsers = await fetchUsers(duration);
      
      if(fetchedUsers.length === 0){
        openPopup("Alert",translate(TranslationEnum.delete_pjp,"No users found in the selected duration"),()=>{});
      }
      setUsers(fetchedUsers);
      setLoading(false);
    } catch (error) {
      openPopup("Alert",translate(TranslationEnum.delete_pjp,"Failed to fetch users"),()=>{});
    }finally {
      setLoading(false);
    }
  };
  const init = async () => {
    try {
      setMainLoading(true);
      const config = await PjpPlanConfig();
      pjpPlanOption.current = config;
      setMainLoading(false);
    } catch (error) {
      console.error("Error fetching PjpPlanConfig:", error);
    }finally {
      setMainLoading(false);
    }
  };
  useEffect(() => {
    if (duration) {
      getUsers(duration);
    }
  }, [duration]);
  useEffect(() => {
    init();
  }, []);
  return mainLoading ? (
    <Loader />
  ) : (
    <div className="deletePJP-wrapper">
      {/* heading (use the common component ) */}
      <DefaultHeading
        heading={translate(TranslationEnum.delete_pjp, "Delete PJP")}
        showDefaultBackButton={true}
      />
      {/* month and year filter */}
      <DurationFilter duration={duration} setDuration={setDuration} />
      {/* select user */}
      {duration &&
        (loading ? (
          <Loader />
        ) : (
          <UsersInfo
            users={users}
            duration={duration}
            pjpPlanOption={pjpPlanOption.current}
            getUsers = {getUsers}
          />
        ))}
    </div>
  );
};

export default DeletePJP;
